import { Document, Header, Footer, Paragraph, Packer, ImageRun } from "docx";
//import { saveAs } from 'file-saver';

// Créer un converter entre les objets et la fonction d'export
// https://docx.js.org

// Génère un nouveau document Word en ajoutant des éléments à une section 
async function exportWord(formatedContent, filename, template="cmem") {

  const getHeader = templates[template].getHeader;
  const getFooter = templates[template].getFooter;

  const doc = new Document({
    sections: [{
      properties: {},
      headers: {
        default: await getHeader(),
      },
      footers: {
        default: await getFooter(),
      },
      children: formatedContent
    }],
  });

  exportFile(doc, filename);
}

// Créer une nouvelle fonction si besoin de plusieurs sections
/* function exportWordSections()...*/

// Fonction d'export au format docx
function exportFile(doc, fileName) {

  //const mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

  //Packer.toBuffer(doc).then(blob => {
  //    console.log("blob: ", blob)
  //    const docBlob = blob.slice(0, blob.size, mimeType);
  //    saveAs(docBlob, fileName + ".docx");
  //}).catch(e => {
  //  console.error("error toBlob:", e);
  //});

  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, fileName + ".docx");
  });

}

const templates = {
  cmem: {
    getHeader: async function () {
      const responseLogo = await fetch("/static/logo.png");
      const blobLogo = await responseLogo.blob();
      const bufferLogo = await blobLogo.arrayBuffer();

      const responseEncart = await fetch("/static/encart.png");
      const blobEncart = await responseEncart.blob();
      const bufferEncart = await blobEncart.arrayBuffer();

      var header = new Header({
        children: [
          new Paragraph({
            children: [
              new ImageRun({
                data: bufferLogo,
                floating: {
                  horizontalPosition: {
                    offset: 200000,
                  },
                  verticalPosition: {
                    offset: 200000,
                  }
                },
                transformation: {
                  width: 159,
                  height: 53,
                },
              }),
              new ImageRun({
                data: bufferEncart,
                floating: {
                  horizontalPosition: {
                    offset: 5653200,
                  },
                  verticalPosition: {
                    offset: 0,
                  }
                },
                transformation: {
                  width: 199,
                  height: 102,
                },
              })
            ],
          }),
        ]
      })
      return header;
    },
    getFooter: async function () {
      return new Footer({
        children: [new Paragraph("")],
      })
    }
  }
}

export default {
  exportWord
}

export {
  exportWord
}



// WEBPACK FOOTER //
// ./src/utils/exportWord.js